/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitMajorAccountChange_submitMajorAccountChange_CreditApplication_validationErrors_CreditApplicationValidationError = { readonly __typename: 'CreditApplicationValidationError', readonly path: string | null, readonly error: string | null };

export type SubmitMajorAccountChange_submitMajorAccountChange_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly validationErrors: ReadonlyArray<SubmitMajorAccountChange_submitMajorAccountChange_CreditApplication_validationErrors_CreditApplicationValidationError | null> | null };

export type SubmitMajorAccountChange_Mutation = { readonly __typename: 'Mutation', readonly submitMajorAccountChange: SubmitMajorAccountChange_submitMajorAccountChange_CreditApplication };


export type SubmitMajorAccountChangeVariables = _Types.Exact<{
  creditTerms: _Types.Scalars['Boolean']['input'];
  creditApplicationId: _Types.Scalars['ID']['input'];
  creditApplicationFetchedAt: _Types.Scalars['NaiveDateTime']['input'];
}>;


export type SubmitMajorAccountChange = SubmitMajorAccountChange_Mutation;


export const SubmitMajorAccountChangeDocument = gql`
    mutation SubmitMajorAccountChange($creditTerms: Boolean!, $creditApplicationId: ID!, $creditApplicationFetchedAt: NaiveDateTime!) {
  submitMajorAccountChange(
    creditTerms: $creditTerms
    creditApplicationId: $creditApplicationId
    creditApplicationFetchedAt: $creditApplicationFetchedAt
  ) {
    salesforceCreditId
    validationErrors {
      path
      error
    }
  }
}
    `;
export type SubmitMajorAccountChangeMutationFn = Apollo.MutationFunction<SubmitMajorAccountChange, SubmitMajorAccountChangeVariables>;

/**
 * __useSubmitMajorAccountChange__
 *
 * To run a mutation, you first call `useSubmitMajorAccountChange` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMajorAccountChange` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMajorAccountChange, { data, loading, error }] = useSubmitMajorAccountChange({
 *   variables: {
 *      creditTerms: // value for 'creditTerms'
 *      creditApplicationId: // value for 'creditApplicationId'
 *      creditApplicationFetchedAt: // value for 'creditApplicationFetchedAt'
 *   },
 * });
 */
export function useSubmitMajorAccountChange(baseOptions?: Apollo.MutationHookOptions<SubmitMajorAccountChange, SubmitMajorAccountChangeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMajorAccountChange, SubmitMajorAccountChangeVariables>(SubmitMajorAccountChangeDocument, options);
      }
export type SubmitMajorAccountChangeHookResult = ReturnType<typeof useSubmitMajorAccountChange>;
export type SubmitMajorAccountChangeMutationResult = Apollo.MutationResult<SubmitMajorAccountChange>;
export type SubmitMajorAccountChangeMutationOptions = Apollo.BaseMutationOptions<SubmitMajorAccountChange, SubmitMajorAccountChangeVariables>;